import { createContext, useState, useMemo } from "react";

export const ViewContext = createContext();

export const ViewContextProvider = (props) => {
  const [peopleView, setPeopleView] = useState("grid");
  const [entriesView, setEntriesView] = useState("grid");
  const [themesView, setThemesView] = useState("grid");
  const [regionsView, setRegionsView] = useState("grid");
  const [unitsView, setUnitsView] = useState("grid");
  const providerValue = useMemo(
    () => ({
      peopleView,
      setPeopleView,
      entriesView,
      setEntriesView,
      themesView,
      setThemesView,
      regionsView,
      setRegionsView,
      unitsView,
      setUnitsView,
    }),
    [peopleView, entriesView, themesView, regionsView, unitsView]
  );

  return (
    <ViewContext.Provider value={providerValue}>
      {props.children}
    </ViewContext.Provider>
  );
};
